import { service } from './service';
import { SORT_ORDER } from '@/resources/Constants'
import _ from 'lodash';
import { getGridPagingParams, mapGridPagingState } from '../../shared/utils';

const DEFAULT_SORT_ORDER = SORT_ORDER.ASC;

const state = {
  all: {},
  files: [],
  paging: {
    ...getGridPagingParams(DEFAULT_SORT_ORDER, 'friendlyName'),
    filters: {
      friendlyName: null,
      fileName: null,
      fileCategory: null,
      uploadedBy: null
    }
  },
  fileContentType: []
};

const getters = {
  files: state => state.files,
};

const actions = {
  async getFiles({ commit },
    {
      pageNumber = state.paging.pageNumber,
      pageSize = state.paging.pageSize,
      sortBy = state.paging.sortBy,
      sortOrder = state.paging.sortOrder,
      filters = state.paging.filters,
      companyId
    } = {},
  ) {
    const results = await service.getFiles(
      companyId,
      pageNumber,
      pageSize,
      sortBy,
      sortOrder,
      filters
    );

    commit('setFiles', results);
  },
  async saveFile({ commit, dispatch }, fileObj) {
    const fileData = new FormData();
    if (fileObj && fileObj.notifiedUsers && fileObj.notifiedUsers.length) {
      fileData.append('notifiedUsers', fileObj.notifiedUsers.map(x => x.value).join(","))
    }
    fileData.append('file', fileObj.file, fileObj.fileName);
    fileData.append('CompanyId', fileObj.companyId);
    fileData.append('FileCategoryId', fileObj.fileCategoryId);
    fileData.append('FileNote', fileObj.fileNote);
    fileData.append('FriendlyName', fileObj.friendlyName);
    fileData.append('FilePassword', fileObj.password);

    const result = await service.saveFile(fileData);

    commit('saveResponse', result);
    dispatch('getFiles', { companyId: result.companyId });
  },
  async getFileContentType({ commit }) {
    const results = await service.getFileContentType();
    commit('setFileContentType', results);
  }
};

const mutations = {
  setFiles(state, payload) {

    const pagingData = payload && payload.paging;

    state.files = payload && payload.items ? payload.items : [];

    state.paging = mapGridPagingState(
      state.paging,
      pagingData
    );

  },
  saveResponse(state, payload) {
    state.saveResponse = payload;
  },
  setFileContentType(state, payload) {
    state.fileContentType = payload;
  }
};

const files = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default files;
